import { jsx as _jsx } from "react/jsx-runtime";
import { FaExclamationCircle } from 'react-icons/fa';
export default function useInputErrorStyling(error, disabled) {
    var invalid = !!(error && error.length > 0);
    var classList = [
        !invalid &&
            !disabled &&
            'border-oncolensOrange-500 focus:ring-oncolensBlue-500 focus:border-oncolensBlue-500',
        invalid &&
            !disabled &&
            'pr-10 text-red-900 placeholder-red-300 border-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500',
        disabled && 'cursor-not-allowed border bg-gray-50 border-gray-300 text-gray-300',
    ];
    return {
        invalid: invalid,
        classList: classList,
        icon: invalid ? (_jsx("div", { className: "w-5 h-5 pointer-events-none", children: _jsx(FaExclamationCircle, { className: "w-5 h-5 text-red-500", xmlns: "http://www.w3.org/2000/svg" }) })) : null,
    };
}
